export const UserManagementTabsEnum = {
  USERS: 0,
  ROLES: 1,
  ACTIVITY_HISTORY: 2,
};

export default UserManagementTabsEnum;

